module.exports = __webpack_public_path__ + "static/entertainment-1e3a0072da9af86434b973e049957f71.png";